<template>
  <div>
    <PageHeader :schema="$schemas.openTitle" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.openTitle"
        :service="$api.openTitles"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateOpenTitle',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
